import styled, { css } from 'styled-components';
import { isMobile } from 'react-device-detect';

interface StyledFinderSettingsProps {
  filterApplied?: boolean;
}

export const StyledFinderSettings = styled.div<StyledFinderSettingsProps>`
  background: ${({ color }) => color || '#998CFF'};
  padding: 8px 16px;
  color: white;
  position: fixed;
  z-index: 2;
  height: 54px;
  ${p =>
    isMobile
      ? css`
          top: calc(env(safe-area-inset-top) + ${p.filterApplied ? '134px' : '115px'});
          left: 0;
          right: 0;
        `
      : css`
          top: ${p.filterApplied ? '144px' : '125px'};
          left: 300px;
          right: 300px;
        `}
  }
`;
